import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const getCDNImage = (path) => {

    if(!path) {
        return ''
    }

    return path.replace(process.env.NEXT_PUBLIC_API_HOST, process.env.NEXT_PUBLIC_CDN_HOST)
}